// redux store
import reduxStore from '../../redux/store';

const getSupplierLogoUrl = ({
  tenantApiUrl = reduxStore.getState()?.auth?.tenant?.apiURL,
  path,
}) => `${tenantApiUrl}/public/logos/${path}.png`;

export default getSupplierLogoUrl;
